import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { Observable } from 'rxjs';
import { queryParamsProducts } from '../financial-setup/model.models';
@Injectable({
    providedIn: 'root'
})
export class FinancialProductService {

    constructor(public api: ApiService) {
    }

    private basePath: string = 'models';

    getAllModels(data: queryParamsProducts): Observable<any> {
        //filtros
        return this.api.post(`${environment.API_QUOTE_SERVICE}/models/all`,data);
    }

    getModels(): Observable<any> {
        return this.api.get(`${environment.API_QUOTE_SERVICE}/models`);
    }

    getYears(): Observable<any> {
        return this.api.get(`${environment.API_QUOTE_SERVICE}/models/years`);
    }

    getSubBrand(): Observable<any> {
      const url = `${environment.API_QUOTE_SERVICE}/models/sub-brands` ;//+ brandId != null ?  `?brandId=${brandId}` : ""
        return this.api.get(url);
    }

    getSubBrandsByIdBrand(idBrand: number): Observable<any> {
        return this.api.get(`${environment.API_QUOTE_SERVICE}/models/sub-brands/${idBrand}`);
    }

    getBrand(): Observable<any> {
        return this.api.get(`${environment.API_QUOTE_SERVICE}/models/brands`);
    }

    getModelsToFinancialSetup(body: any): Observable<any> {
      return this.api.post(`${environment.API_QUOTE_SERVICE}/models/all-financial-setup`, body);
    }


    getBrandsAndSubBrandsForModelType(body: {
      modelType: string;
      classification?: boolean | null;
      year?: number | null;
      brandId?: number | null;
      subBrandId?: number | null;
    }): Observable<any> {
      return this.api.post(`${environment.API_QUOTE_SERVICE}/models/brand-sub-brand`, body);
    }

    createNewProduct(data: queryParamsProducts): Observable<any> {
        return this.api.post(`${environment.API_QUOTE_SERVICE}/models/create`, data);
    }

    getModelById(id: number): Observable<any> {
        return this.api.get(`${environment.API_QUOTE_SERVICE}/models/${id}`);
    }

    updateProduct(id: number, data: any): Observable<any> {
        return this.api.put(`${environment.API_QUOTE_SERVICE}/models/${id}`, data);
    }

    validateNewProduct(data: any): Observable<any> {
        return this.api.post(`${environment.API_QUOTE_SERVICE}/models/validate/new`, data);
    }
}

